/* eslint-disable */
import NativeApi from 'native-api'
import browser from '@/util/browser'
import { Notify } from 'vant'
// import Qs from 'qs'
// import axios from 'axios'
const { guaguaApp: isApp, isGUAGUA, isCheSuPai } = browser

const pNotify = Notify
const mNotify = Notify

const NOT_LOG_IN = 'E00007'
const NOT_LOG_IN_PREV = 2
const REQUEST_SUCCESS = 'S00000'
const REQUEST_SUCCESS_PREV = 0
const NO_PERMISSION_STATUS = 401
const NOT_LOG_IN_STATUS = 302
const SERVER_ERROR_STATUS = 500

let userInfo

/**
 * 呱呱 APP端获取当前登录人用户信息（token等）
*/
export function userInfoReady() {
    return new Promise((resovle, reject) => {
        if (userInfo) {
            resovle(userInfo)
        } else {
            if (isGUAGUA || isCheSuPai) {
                NativeApi.invoke('getUserInfo', null, (info) => {
                    if (info.error) {
                        reject(info.error)
                    } else {
                        userInfo = info
                        resovle(userInfo)
                    }
                })
            } else {
                resovle({})
            }

        }
    })
}

/**
 * 未登录时跳转登录页
 * @param {*} redirectUrl
 */
function jumpLoginPage(redirectUrl) {
    window.location.href = `${redirectUrl.replace(/guazi-cloud.com/g, 'guazi-corp.com')}?returnUrl=${encodeURIComponent(window.location.href)}`
}

/**
 * 处理基本APP端认证信息Token
 * @param {*} request
 */
function baseUseRequest(request) {
    return new Promise((resolve) => {
        if (!isApp) {
            // return request
            resolve(request)
        }
        request.headers.clientType = 'APP'
        userInfoReady().then((info) => {
            request.headers.token = info.token || ''
            resolve(request)
        }).catch((err) => {
            // mNotify('无法获取用户信息')
            resolve(request)
        })
    })
}

/**
 * 处理请求错误
 * @param {*} error
 */
function handleBadRequest(error) {
    const { response } = error
    const aNotify = isApp ? mNotify : pNotify
    if (response) {
        const { status, data: { redirectUrl, message = '', messages = {} } = {} } = response
        if (status === NOT_LOG_IN_STATUS) {
            jumpLoginPage(redirectUrl)
            return
        }
        if (status >= SERVER_ERROR_STATUS) {
            if (message) {
                aNotify(`${status}: ${response.data.message}`)
            } else {
                aNotify('系统出了一点小问题～')
            }
            return Promise.reject(error)
        }
        if (status === NO_PERMISSION_STATUS) {
            aNotify('没有权限')
            return Promise.reject(error)
        }
        let errors = ''
        for (const msg in messages) {
            if (messages.hasOwnProperty(msg)) {
                errors += `${msg}:${response.data.messages[msg].join('|')}\n`
            }
        }
        errors = errors || `${status}:${response.data.message}`
        errors && aNotify(errors)
        return Promise.reject(error)
    }
    if (!(error && error.hasOwnProperty('message') && error.message && (error.message.indexOf('post&') > -1 || error.message.indexOf('get&') > -1) || error.message.indexOf('put&') > -1 || error.message.indexOf('delete&') > -1)) {
        aNotify('接口错误, 请重试或联系开发人员')
    }

    return Promise.reject(error)
}


/**
 * 单一业务状态处理途径拦截器
 * 会在接口请求成功后的，接口业务状态码code不等于REQUEST_SUCCESS或者REQUEST_SUCCESS_PREV时弹出错误信息
 * 适用于单一关注业务状态码（REQUEST_SUCCESS）成功时处理业务的接口请求
 * @param {*} instance
 */
export function singlepathInterceptor(instance) {
    instance.interceptors.request.use(baseUseRequest)
    instance.interceptors.response.use(
        (response) => {
            if (typeof response.data === 'string') {
                pNotify(response.data)
                let error = new Error('接口请求失败')
                error.response = response
                return Promise.reject(error)
            }
            const { data: { code = '', message = '', redirectUrl = '' } } = response
            if (!isApp) {
                if (code === NOT_LOG_IN || code === NOT_LOG_IN_PREV) {
                    jumpLoginPage(redirectUrl)
                    return
                }
                if (code === NO_PERMISSION_STATUS) {
                    pNotify(message || '没有权限')
                    let error = new Error(message || '没有权限')
                    error.response = response
                    return Promise.reject(error)
                }
                if (code !== REQUEST_SUCCESS && code !== REQUEST_SUCCESS_PREV) {
                    pNotify(message)
                    let error = new Error('接口请求失败')
                    error.response = response
                    return Promise.reject(error)
                }
            } else {
                if (code !== REQUEST_SUCCESS && code !== REQUEST_SUCCESS_PREV) {
                    if (code === NOT_LOG_IN_PREV) {
                        NativeApi.invoke('login', null, (result) => {
                            const { code: rCode, message: rMsg } = result
                            if (rCode) {
                                mNotify(rMsg) // 登录失败

                            } else {
                                window.location.reload()
                            }
                        })
                    } else {
                        message && mNotify(message)
                    }
                    let error = new Error('接口请求失败')
                    error.response = response
                    return Promise.reject(response)
                }
            }
            return response
        },
        (error) => {
            handleBadRequest(error)
        },
    )
}

/**
 * 增加防止重复请求
 */
// const pendingRequest = new Map();

// function generateReqKey(config) {
//     const { method, url, params, data } = config;
//     return [method, url, Qs.stringify(params), Qs.stringify(data)].join("&");
// }

// function addPendingRequest(config) {
//     const requestKey = generateReqKey(config);
//     config.cancelToken =
//         config.cancelToken ||
//         new axios.CancelToken((cancel) => {
//             if (!pendingRequest.has(requestKey)) {
//                 pendingRequest.set(requestKey, cancel);
//             }
//         });
// }

// function removePendingRequest(config) {
//     const requestKey = generateReqKey(config);
//     if (pendingRequest.has(requestKey)) {
//         const cancel = pendingRequest.get(requestKey);
//         cancel(requestKey);
//         pendingRequest.delete(requestKey);
//     }
// }

/**
 * 多业务状态处理途径拦截器
 * 适用于关注多种业务状态码情形时处理业务的接口请求
 * @param {*} instance
 */
export function multipathInterceptor(instance) {
    // 增加重复提交
    instance.interceptors.request.use((config) => {
        // removePendingRequest(config); // 检查是否存在重复请求，若存在则取消已发的请求
        // addPendingRequest(config); // 把当前请求添加到pendingRequest对象中
        return baseUseRequest(config)
    })

    instance.interceptors.response.use(
        (response) => {
            // removePendingRequest(response.config); // 从pendingRequest对象中移除请求
            if (typeof response.data === 'string') {
                pNotify(response.data)
                let error = new Error('接口请求失败')
                error.response = response
                return Promise.reject(error)
            }
            const { data: { code = '', redirectUrl = '', message = '' } } = response
            if (!isApp) {
                if (code === NOT_LOG_IN || code === NOT_LOG_IN_PREV) {
                    jumpLoginPage(redirectUrl)
                    return
                }
                // 抱歉，您无权访问
                if (code === 'E20003') {
                    Notify({ type: 'danger', message: '抱歉，您无权访问' })
                    let error = new Error(message || '抱歉，您无权访问')
                    error.response = response
                    return Promise.reject(error)
                }
                if (code === NO_PERMISSION_STATUS) {
                    pNotify(message || '没有权限')
                    let error = new Error(message || '没有权限')
                    error.response = response
                    return Promise.reject(error)
                }
                if (code !== REQUEST_SUCCESS && code !== REQUEST_SUCCESS_PREV) {
                    let error = new Error('接口返回非成功状态码')
                    error.response = response
                    return Promise.reject(error)
                }
            } else {
                if (code !== REQUEST_SUCCESS && code !== REQUEST_SUCCESS_PREV) {
                    let error
                    if (code === NOT_LOG_IN_PREV) {
                        NativeApi.invoke('login', null, (result) => {
                            const { code: rCode, message: rMsg } = result
                            if (rCode) {
                                mNotify(rMsg) // 登录失败
                            } else {
                                window.location.reload()
                            }
                        })
                    } else if (code === 'E20003') { // 抱歉，您无权访问
                        Notify({ type: 'danger', message: '抱歉，您无权访问' })
                        error = new Error('抱歉，您无权访问')
                    } else {
                        error = new Error('接口返回非成功状态码')
                    }
                    error.response = response
                    return Promise.reject(error)
                }
            }
            return response
        },
        (error) => {
            // removePendingRequest(error.config || {}); // 从pendingRequest对象中移除请求
            handleBadRequest(error)
        },
    )
}

/**
 * Blob二进制流下载拦截器
 * 适用于PC端二进制流数据文件下载
 * 需要额外传入设置下载文件全名称
 * @param {*} instance
 * @param {*} fileParams
 */
export function blobDownloadInterceptors(instance, { fileName } = {}) {
    instance.interceptors.request.use(baseUseRequest)
    instance.interceptors.response.use(
        (response) => {
            const { data } = response
            if (data.type === 'application/json') {
                let reader = new FileReader()
                reader.addEventListener('loadend', function () {
                    const { code, message, redirectUrl } = JSON.parse(reader.result)
                    if (code === NOT_LOG_IN || code === NOT_LOG_IN_PREV) {
                        jumpLoginPage(redirectUrl)
                    } else if (code === NO_PERMISSION_STATUS) {
                        pNotify(message || '没有权限')
                        let error = new Error(message || '没有权限')
                        error.response = response
                        return Promise.reject(error)
                    } else {
                        pNotify(message || '导出下载失败')
                        let error = new Error('下载失败')
                        error.response = response
                        Promise.reject(error)
                    }
                })
                reader.readAsText(data, 'utf-8')
            } else {
                const blob = new Blob([data])
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                } else { // IE10+下载
                    navigator.msSaveBlob(blob, fileName)
                }
            }
            return response
        },
        (error) => {
            handleBadRequest(error)
        },
    )
}
